/**
 * Tracks which payments originated from digital bills.
 * Used to show contextual UI (e.g. "Open table" instead of "Discard order")
 * when a payment fails after the user has navigated away from the digital bill.
 */
const digitalBillOrigins = new Map<string, string>();

export function trackDigitalBillPayment(paymentReference: string, digitalBillReference: string) {
  digitalBillOrigins.set(paymentReference, digitalBillReference);
}

export function getDigitalBillReference(paymentReference: string | undefined): string | undefined {
  if (!paymentReference) {
    return undefined;
  }
  return digitalBillOrigins.get(paymentReference);
}

export function clearPaymentOrigin(paymentReference: string) {
  digitalBillOrigins.delete(paymentReference);
}
